module.exports = __webpack_public_path__ + "static/media/thunderstorms.abedfdf7.svg";